ScoreTrekBattle.Tournament = (function() {
    var _this, STATUS;

    STATUS = {
        tournament: null
    };

    function renderModeInfoItem(title, content) {
        return [`<div class="mt-small">`,
            `<div>${title}</div>`,
            `<div class="mt-tiny color-blue">${content}</div>`,
        `</div>`].join('');
    }

    function renderMissingTournamentItem() {
        return $(`<div class="text-white-50"><i class="fa-solid fa-ban"></i> ${__i18n('error/TOURNAMENT_DOES_NOT_EXIST')}</div>`);
    }

    function getGroupSize(playersCount, groupsCount) {
        var playersPerGroup, playersPerGroupMin, playersPerGroupMax;
        playersPerGroup = playersCount / groupsCount;
        playersPerGroupMin = Math.floor(playersPerGroup);
        playersPerGroupMax = Math.ceil(playersPerGroup);
        return countToString(playersPerGroupMin, playersPerGroupMax);

    }

    function countToString(countMin, countMax) {
        return (countMin === countMax) ? String(countMin) : `${countMin} / ${countMax}`;
    }

    _this = {
        setCurrent: function(tournament) {
            STATUS.tournament = tournament;
        },

        getCurrent: function() {
            return STATUS.tournament;
        },

        getCurrentName: function(tournamentId) {
            var hasTournament;

            hasTournament = STATUS.tournament && (!tournamentId || (STATUS.tournament.id === tournamentId));

            return hasTournament ? STATUS.tournament.title : __i18n('share/name/tournament');
        },

        getMapsUrl: function(tournament) {
            if (!tournament) {
                return 'javascript:'
            }
            return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${tournament.locationStreet}, ${tournament.locationZip} ${tournament.locationCity}`)}`;
        },

        getMenuLink: function(tournamentStatus) {
            switch (tournamentStatus) {
                case 'my':
                    return '/tournament/my';
                case 'plan':
                    return '/tournament/create';
                case 'series':
                    return '/series/list';
                case 'sealed':
                    return '/tournament/done';
                case 'running':
                case 'done':
                    return '/tournament/running';
                default:
                    return '/tournament/scheduled';
            }
        },

        getLink: function(tournament) {
            if (!tournament) {
                return '/';
            }
            if (tournament.isFinalized || (['running', 'done'].indexOf(tournament.status) >= 0)) {
                return `/tournament/live/${tournament.id}`;
            }
            return `/tournament/details/${tournament.id}`;
        },

        getShareHash: function(tournamentId) {
            return `/tournament/live/${tournamentId}`;
        },

        getQualificantsCountLabel: function(qualificantsCount) {
            qualificantsCount = parseInt(qualificantsCount, 10);
            if (!qualificantsCount || (qualificantsCount < 0)) {
                return `<span style="opacity:0.5">${__i18n('tournament/create/choice/koQualify/none')}</span>`;
            }
            if (qualificantsCount === 1) {
                return __i18n('tournament/create/choice/koQualify/single/icon');
            }
            return __i18n('tournament/create/choice/koQualify/multi/icon', {koQualify: qualificantsCount});
        },

        renderSelectItem: function(tournament) {
            return $('<span>').append(
                $('<span>').addClass('color-white-60').text(tournament.dateTimeTournament),
                '<br>',
                `${tournament.isPublic ? '' : '<i class="color-red text-smaller"><i class="fa-solid fa-eye-slash"></i></i> '}`,
                $('<span>').text(tournament.title)
            );  
        },

        renderPrevTournaments: function(prevTournaments, $parent) {
            return new Promise(resolve => {
                let tournamentPromises;

                if (!prevTournaments || (prevTournaments.length === 0)) {
                    resolve();
                    return;
                }

                tournamentPromises = [];

                prevTournaments.forEach(tournament => {
                    tournamentPromises.push(_this.renderTournamentItem(tournament, '<i class="fa-solid fa-diagram-project"></i>'));
                });

                Promise.all(tournamentPromises).then($tournaments => {
                    $parent.empty().append($tournaments);
                    resolve();
                });
            });
        },

        renderNextTournament: function(nextTournament, $parent, qualificantsCount) {
            return new Promise(resolve => {
                if (!nextTournament) {
                    resolve();
                    return;
                }

                _this.renderTournamentItem(nextTournament, '<i class="fa-solid fa-sitemap"></i>', qualificantsCount).then($tournament => {
                    $parent.empty().append($tournament);
                    resolve();
                });
            });
        },

        renderTournamentItem: function(tournament, icon, qualificantsCount, isForeign) {
            return new Promise(function(resolve) {
                if (!tournament) {
                    resolve(renderMissingTournamentItem());
                }

                ScoreTrekBattle.Template.render('tournament/details/tournamentItem', {
                    tournament: tournament
                }, true).then(tournamentView => {
                    if (qualificantsCount) {
                        tournamentView.$view.find('[data-id="qualificantsCount"]').html(_this.getQualificantsCountLabel(qualificantsCount));
                    } else {
                        tournamentView.$view.find('[data-id="qualificantsCountWrapper"]').remove();
                    }

                    tournamentView.$view.find('[data-id="tournamentItem"]').toggleClass('isForeign', !!isForeign);
                    tournamentView.$view.find('[data-id="icon"]').html(icon);
                    resolve(tournamentView.$view)
                }).catch(error => {
                    console.error(error);
                    resolve(renderMissingTournamentItem());
                });
            });
        },

        renderInfos: function(tournament, $view) {
            let hasOrganization;

            if (!tournament) {
                return;
            }

            hasOrganization = false;

            ['entryFee', 'approvalNumber', 'dressCode', 'hasRegistration', 'hasWithdrawLimit'].forEach(fieldName => {
                if (tournament[fieldName]) {
                    hasOrganization = true;
                } else {
                    $view.find(`[data-id="${fieldName}"]`).remove();
                }
            });

            if (!hasOrganization) {
                $view.find('[data-id="organization"]').remove();
            }
        },

        renderModeInfo: function(tournament, $view) {
            let modeInfo, preset;

            if (!tournament || !tournament.preset || !tournament.preset.preset) {
                return;
            }

            modeInfo = [];
            preset = tournament.preset.preset;

            modeInfo.push(renderModeInfoItem(__i18n('game/type'), [
                `${__i18n(`gameType/${preset.gameType}`)}`,
                ScoreTrekBattle.Tournament.Preset.Edit.allowAlternatingBreak(preset.gameType) ? `, ${__i18n(`modeInfo/alternatingBreak/${preset.alternatingBreak}`)}` : ''
            ].join('')));

            if (preset.groupCount > 0) {
                modeInfo.push(renderModeInfoItem(__i18n('modeInfo/groupPhase'), __i18n(`modeInfo/groupsWithPlayers/${preset.playerType}`, {
                    groupCount: preset.groupCount,
                    groupSize: getGroupSize(preset.playerLimit, preset.groupCount),
                    teamSize: preset.teamSize
                })));

                modeInfo.push(renderModeInfoItem(__i18n('modeInfo/qualification/group'), __i18n(`tournament/create/choice/groupQualify/label/${preset.groupQualify}`)));
            }

            if (preset.koSystem && (preset.koSystem !== 'no')) {
                modeInfo.push(renderModeInfoItem(__i18n('modeInfo/koSystem'), __i18n(`player/koSystem/${preset.koSystem}`)));

                if (preset.koSystemSingle && (preset.koSystemSingle > 2)) {
                    modeInfo.push(renderModeInfoItem(__i18n('player/koSystem/single'), __i18n(`tournament/create/choice/koSystemSingle/last${preset.koSystemSingle}/label`)));
                }
            }

            $view.find('[data-id="modeInfo"]').html(modeInfo.join(''));
        }

    };

    return _this;
})();

addEventListener("DOMContentLoaded", () => {
    ScoreTrekBattle.View.registerRedirect('/tournament/create', '/tournament/preset/list');
    ScoreTrekBattle.View.registerRedirect('/tournament/preset', '/tournament/preset/list');
});
